import moment from 'moment'
import { gql } from '@apollo/client'
import { DATE_CLOSED_QUERY, BILLING_NUMBER_QUERY, MONTH_END_TABLE_QUERY, MONTH_END_DATE_QUERY, BILLING_NUMBER_TK_QUERY, EXECUTE_SQL_QUERY } from '../graphql'
import { ACTION_TYPE, FIELD_TYPE } from '../constants'
import { FIELD_ID } from '../components/CustomCode/Asbestos/asbestos_constants'
import { makeInteger } from '../utils'
import SelectFile from '../components/CustomCode/Asbestos/SelectFile'

const DATE_CLOSED = gql(DATE_CLOSED_QUERY)
const BILLING_NUMBER = gql(BILLING_NUMBER_QUERY)
const MONTH_END_TABLE = gql(MONTH_END_TABLE_QUERY)
const MONTH_END_DATE = gql(MONTH_END_DATE_QUERY)
const BILLING_NUMBER_TK = gql(BILLING_NUMBER_TK_QUERY)
const EXECUTE_SQL = gql(EXECUTE_SQL_QUERY)

function selectedNames(formInputs, selectFieldId) {
  const names = []
  const selectInput = formInputs[selectFieldId]
  const selectValues = selectInput.currentValue
  if (selectValues && selectValues.length > 0) {
    for (let selectValue of selectValues) {
      names.push(selectValue.name)
    }
  }
  return names
}

const fw = {
// Date Closed
  date_closed_validation: async function date_closed_validation(fieldInput, objectId, formInputs) {
    let validationMessage = ''
    if (fieldInput.currentValue) {
      let savedDateClosed = null
      try {
        const results = await window.apolloClient.query({ query: DATE_CLOSED, variables: { casePlaintiffId: objectId } })
        if (results.data.dateClosed) {
          savedDateClosed = results.data.dateClosed
        }
        console.log(`savedDateClosed: ${savedDateClosed} newDateClosed: ${fieldInput.currentValue}`)
        if (!savedDateClosed || savedDateClosed !== fieldInput.currentValue) {
          if (moment(fieldInput.currentValue).isBefore(moment().format('YYYY-MM-DD'))) {
            validationMessage = `${fieldInput.field.name} cannot be before today.`
          }
        }
      } catch (err) {
        console.log(JSON.stringify(err))
        validationMessage = JSON.stringify(err)
      }
    }
    return validationMessage
  },

  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    console.log('fw.validation_hook', fieldInput, objectId, formInputs)

    let validationMessage = ''
    let fieldType = makeInteger(fieldInput.field.type.id)

    // Settlement Log: Partial Payment Reason, Notes
    let fields = [
      FIELD_ID.settlementLog.multiplePartialPaymentReason, 
      FIELD_ID.settlementLog.notes
    ]
    if (fields.includes(makeInteger(fieldInput.field.id))) {
      const partialPayment = formInputs[FIELD_ID.settlementLog.partialPayment]
      if ((!fieldInput.currentValue || (typeof fieldInput.currentValue === 'object' && !fieldInput.currentValue.id)) &&  partialPayment.currentValue === 'Y') {
        validationMessage = `${fieldInput.field.name} cannot be left blank when ${partialPayment.field.name} is "Yes".`
      }
    }

    // Timekeeper Code
    if (makeInteger(fieldInput.field.id) === FIELD_ID.timekeeper.code) {
      if (fieldInput.currentValue) {
        const timekeeperFirmId = formInputs[FIELD_ID.timekeeper.firm].currentValue.id
        if (timekeeperFirmId) {
          try {
            let count = 0
            const sql = `
              SELECT COUNT(*) 
              FROM tb_timekeeper 
              WHERE timekeeper_code = '${fieldInput.currentValue}' 
                AND timekeeper_firm = ${timekeeperFirmId} 
                AND timekeeper_id != ${objectId}
            `
            const results = await window.apolloClient.query({ query: EXECUTE_SQL, variables: { sql: sql } })
            console.log(results)
            if (results.data.executeSQL && results.data.executeSQL.length > 0) {
              count = parseInt(results.data.executeSQL[0])
            }
            if (count > 0) {
              const timekeeperFirmName = formInputs[FIELD_ID.timekeeper.firm].currentValue.name
              const timekeeperFirmFieldName = formInputs[FIELD_ID.timekeeper.firm].field.name
              validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used by ${timekeeperFirmFieldName} "${timekeeperFirmName}".`
            }
          } catch (err) {
            console.log(JSON.stringify(err))
            validationMessage = JSON.stringify(err)
          }
        }
      }
    }

    // National Counsel Billing Number
    if (makeInteger(fieldInput.field.id) === FIELD_ID.casePlaintiff.nationalCounselBillingNumber) {

      if (fieldInput.currentValue) {
        try {
          let count = 0
          const results = await window.apolloClient.query({ query: BILLING_NUMBER, variables: { billingNumber: fieldInput.currentValue, id: objectId } })
          if (results.data.billingNumber) {
            count = results.data.billingNumber
          }
          if (count > 0) {
            validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used.`
          }
        } catch (err) {
          console.log(JSON.stringify(err))
          validationMessage = JSON.stringify(err)
        }
       
      }
    }

    // Month End Table Name
    if (makeInteger(fieldInput.field.id) === FIELD_ID.monthEndDate.tableName) {
      if (fieldInput.currentValue) {
        try {
          let count = 0
          const results = await window.apolloClient.query({ query: MONTH_END_TABLE, variables: { tableName: fieldInput.currentValue, id: objectId } })
          if (results.data.monthEndTable) {
            count = results.data.monthEndTable
          }
          if (count > 0) {
            validationMessage = `${fieldInput.field.name} "${fieldInput.currentValue}" is already being used.`
          }
        } catch (err) {
          console.log(JSON.stringify(err))
          validationMessage = JSON.stringify(err)
        }
      }
    }

    // Month End Date
    if (makeInteger(fieldInput.field.id) === FIELD_ID.monthEndDate.monthEndDate) {
      if (fieldInput.currentValue) {
        try {
          let count = 0
          const results = await window.apolloClient.query({ query: MONTH_END_DATE, variables: { date: fieldInput.currentValue, id: objectId } })
          if (results.data.monthEndDate) {
            count = results.data.monthEndDate
          }
          if (count > 0) {
            validationMessage = `${fieldInput.field.name} "${moment(fieldInput.currentValue).format('MM-DD-YYYY')}" is already being used.`
          }
        } catch (err) {
          console.log(JSON.stringify(err))
          validationMessage = JSON.stringify(err)
        }
      }
    }

    // Settlement Amount = sum of Settlement Detail amounts
    if (makeInteger(fieldInput.field.id) === FIELD_ID.casePlaintiff.settlementAmount) {
      let settlementAmount = 0
      if (fieldInput.currentValue) {
        settlementAmount = parseFloat(fieldInput.currentValue)
        let sumDetail = 0
        const details = formInputs[FIELD_ID.casePlaintiff.settlementDetailsRefList]

        for (let gridRow of details.currentValue.gridData) {
          const detail = details.currentValue[gridRow[0]]
          let detailAmount = 0
          if (detail) {
            detailAmount = detail[FIELD_ID.casePlaintiff.settlementDetails.settlementAmount].currentValue
          } else {
            detailAmount = gridRow[1] ? parseFloat(gridRow[1].trim().replace('$', '').replace(/,/g, '')) : 0
          }
          sumDetail += detailAmount ? detailAmount * 100 : 0
          console.log(`fw.validation_hook: detailAmount: ${detailAmount} sumDetail: ${sumDetail/100}`)
        }

        // for (let detailId in details.currentValue) {
        //   if (parseInt(detailId)) {
        //     const detail = details.currentValue[detailId]
        //     const detailAmount = detail[FIELD_ID.casePlaintiff.settlementDetails.settlementAmount].currentValue
        //     sumDetail += detailAmount ? detailAmount * 100 : 0
        //     console.log(`fw.validation_hook: detailAmount: ${detailAmount} sumDetail: ${sumDetail}`)
        //   }
        // }

        console.log(`fw.validation_hook: sumDetail: ${sumDetail/100} settlementAmount: ${settlementAmount}`)
        if (sumDetail / 100 !== settlementAmount) {
          const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
          console.log(`fw.validation_hook: sumDetail: ${sumDetail}`)
          const refListName = formInputs[FIELD_ID.casePlaintiff.settlementDetailsRefList].field.name
          const formattedSumDetail = formatter.format(sumDetail/100)
          const formattedAmount = formatter.format(settlementAmount)
          validationMessage = `The ${fieldInput.field.name} (${formattedAmount}) must equal the sum of the ${refListName} (${formattedSumDetail}).`
        }
      }
    }
  
    // Source = "Complaint"
    fields = [
      FIELD_ID.casePlaintiff.firstName,
      FIELD_ID.casePlaintiff.lastName,
      FIELD_ID.casePlaintiff.plaintiffCounsel,
      FIELD_ID.casePlaintiff.defenseCounsel,
      FIELD_ID.casePlaintiff.damagesSought,
      FIELD_ID.casePlaintiff.currentDiagnosis,
      FIELD_ID.casePlaintiff.logSequenceNumber,
      FIELD_ID.casePlaintiff.clientCode,
      FIELD_ID.casePlaintiff.court
    ]
    if (fields.includes(makeInteger(fieldInput.field.id))) {
      if (!fieldInput.currentValue || (fieldInput.currentValue && fieldType === FIELD_TYPE.select && !fieldInput.currentValue.id)) {
        if (makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
          const source = selectedNames(formInputs, FIELD_ID.casePlaintiff.source)
          if (source.includes('Complaint')) {
            const sourceFieldName = formInputs[FIELD_ID.casePlaintiff.source].field.name
            validationMessage = `${fieldInput.field.name} is mandatory when "Complaint" is selected for ${sourceFieldName}.`
          }
        }
      }
    }

    // Source = "Agreement"
    fields = [
      FIELD_ID.casePlaintiff.firstName,
      FIELD_ID.casePlaintiff.lastName,
      FIELD_ID.casePlaintiff.plaintiffCounsel,
      FIELD_ID.casePlaintiff.currentDiagnosis,
      FIELD_ID.casePlaintiff.logSequenceNumber,
      FIELD_ID.casePlaintiff.clientCode,
      FIELD_ID.casePlaintiff.totalBeginningExposure,
      FIELD_ID.casePlaintiff.totalEndExposure,
      FIELD_ID.casePlaintiff.agreement,
      FIELD_ID.casePlaintiff.groupId
    ]
    if (fields.includes(makeInteger(fieldInput.field.id))) {  
      if ((!fieldInput.currentValue || (fieldInput.currentValue && fieldType === FIELD_TYPE.select && !fieldInput.currentValue.id))) {
        if (makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
          const source = selectedNames(formInputs, FIELD_ID.casePlaintiff.source)
          if (source.includes('Agreement')) {
            const sourceFieldName = formInputs[FIELD_ID.casePlaintiff.source].field.name
            validationMessage = `${fieldInput.field.name} is mandatory when "Agreement" is selected for ${sourceFieldName}.`
          }
        }
      }
    }


    // Court Location, Court State, Court Type
    fields = [
      FIELD_ID.casePlaintiff.court.location, 
      FIELD_ID.casePlaintiff.court.state,
      FIELD_ID.casePlaintiff.court.type
    ]
    console.log('*************************** fields: ', fields, 'fieldInput.field.id: ', fieldInput.field.id)
    if (fields.includes(makeInteger(fieldInput.field.id))) {
      console.log('fw.validation_hook: ', fieldInput.field.name)
      if (!fieldInput.currentValue || (typeof fieldInput.currentValue === 'object' && !fieldInput.currentValue.id)) {
        if (makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
          console.log('fw.validation_hook: allInputs: ', window.rootFormInputs[FIELD_ID.case.plaintiffsRefList])
          const source = selectedNames(window.refListSubmitInputs[0], FIELD_ID.casePlaintiff.source)
          console.log('fw.validation_hook: source: ', source)
          if (source.includes('Agreement') && (makeInteger(fieldInput.field.id) === FIELD_ID.casePlaintiff.court.location)) {
            validationMessage = ''
          } else {
            validationMessage = `${fieldInput.field.name} is mandatory when adding a new record.`
          }
        }
      }
    }

    // Source
    if (makeInteger(fieldInput.field.id) === FIELD_ID.casePlaintiff.source) {
      if (fieldInput.currentValue.length === 0) {
        if (makeInteger(formInputs.action.type.id) === ACTION_TYPE.submit) {
          validationMessage = `${fieldInput.field.name} is mandatory when adding a new record.`
        }
      }
    }

    // Month End Date
    if (makeInteger(fieldInput.field.id) === FIELD_ID.casePlaintiff.nationalCounselBillingNumberTK) {
      if (fieldInput.currentValue) {
        try {
          let ids 
          const results = await window.apolloClient.query({ query: BILLING_NUMBER_TK, variables: { billingNumberTK: fieldInput.currentValue, id: objectId } })
          if (results.data.billingNumberTK) {
            ids = results.data.billingNumberTK
          }
          if (ids.length > 0) {
            validationMessage = `TK billing number "${fieldInput.currentValue}" is already being used in record ID ${ids[0]}.`
          }
        } catch (err) {
          console.log(JSON.stringify(err))
          validationMessage = JSON.stringify(err)
        }
      }
    }
    return validationMessage
  },

  select_file: function select_file(object, field, formInputs, handleChange, hasChanged, fileInfo, setFileInfo) {
    return (
      <SelectFile 
        field={field}
        handleChange={handleChange}
        hasChanged={hasChanged}
        fileInfo={fileInfo}
        setFileInfo={setFileInfo}
      />
    )
  },

}

export default fw